import React from "react";

import { Text, TouchableOpacity, StyleSheet } from "react-native";

import { FontAwesome5 } from "@expo/vector-icons";

const CheckboxDocument = ({
    selected,
    onPress,
    style,
    textStyle,
    size = 30,
    color = "#211f30",
    text = "",
    type
}) => {
    return (
        <TouchableOpacity
            style={[styles.checkBox, style]}
            onPress={() => onPress(type)}
        >
            <FontAwesome5
                size={size}
                color={color}
                name={selected ? "check-circle" : "circle"}
            />

            <Text style={textStyle}> {text} </Text>
        </TouchableOpacity>
    );
}

export default CheckboxDocument;

const styles = StyleSheet.create({
    checkBox: {
        flexDirection: "row",
        alignItems: "center",
    },
});